import { useLanguage } from '../context/LanguageContext';

export default function Personas() {
  const { t } = useLanguage();
  const people = ['1', '2', '3', '4'].map((n) => ({
    n,
    title: t(`who.${n}.title`),
    body: t(`who.${n}.body`),
  }));

  return (
    <div className="grid grid-2">
      {people.map((p) => (
        <article className="persona card card--hover" key={p.n}>
          <h3 className="persona__title">{p.title}</h3>
          <p>{p.body}</p>
        </article>
      ))}
    </div>
  );
}
